module.exports = __webpack_public_path__ + "img/interpersonalRelationship.cf93eff1.svg";